import { render } from "./SemakHakMilikForm.vue?vue&type=template&id=3413ed1b"
import script from "./SemakHakMilikForm.vue?vue&type=script&lang=js"
export * from "./SemakHakMilikForm.vue?vue&type=script&lang=js"

import "./SemakHakMilikForm.vue?vue&type=style&index=0&id=3413ed1b&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__